import { Button, DatePicker, Icons } from '@pankod/refine-antd'
import dayjs from 'dayjs'
import { useState } from 'react'
import { DEFAULT_DATE_FORMAT } from 'utility/constants'

type EditableDateFieldProps = {
  record: any
  field: string
  handleSave: (value: any, record: any) => void
}

export const EditableDateField: React.FC<EditableDateFieldProps> = ({ record, field, handleSave }) => {
  const [editMode, setEditMode] = useState(false)
  const currentValue = record?.[field]

  if (editMode) {
    return (
      <DatePicker
        autoFocus
        value={currentValue ? dayjs(currentValue) : null}
        onChange={(date: dayjs.Dayjs | null) => {
          const dateString = date ? date.toISOString() : null
          handleSave(dateString, record)
          setEditMode(false)
        }}
        onOpenChange={(open: boolean) => {
          if (!open) setEditMode(false)
        }}
        format={DEFAULT_DATE_FORMAT}
      />
    )
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span>{currentValue ? dayjs(currentValue).format(DEFAULT_DATE_FORMAT) : '-'}</span>
      <Button
        shape='circle'
        style={{ border: 'none' }}
        icon={<Icons.EditOutlined />}
        onClick={() => setEditMode(true)}
      />
    </span>
  )
}
